import React, { useReducer } from 'react';
import axios from 'axios';
import AuthReducer from './authReducer'
import AuthContext from './authContext'
import { SET_AUTH, SET_LEAD, RESET_FLOW, SET_PAGE_INFO, GO_BACK, SET_LEAD_LOADING, HIDE_LEAD_LOADING, SET_STEP_LOADING, HIDE_STEP_LOADING, TOGGLE_MODAL } from '../types';
import toastr from 'toastr'
import $ from 'jquery';
import queryString from 'query-string';

let apiUser;
let apiPass;
let apiUrl;
let pageId;
apiUser = process.env.REACT_APP_API_USER;
apiPass = process.env.REACT_APP_API_PASS
apiUrl = process.env.REACT_APP_API_URL;
pageId = process.env.REACT_APP_PAGE_ID;
let url = window.location.search;
let docusignJWT = queryString.parse(url).jwt;
let utm_source = queryString.parse(url).utm_source;
let utm_campaign = queryString.parse(url).utm_campaign;
const AuthState = props => {
    const initialState = {
        lp: null,
        lead: null,
        leadLoading: true,
        stepLoading: false,
        modal: null,
        step: process.env.REACT_APP_FIRST_STEP,
    }
    const [state, dispatch] = useReducer(AuthReducer, initialState);

    // login to API and get token
    const getToken = async () => {
        setLoading('lead');
        const $token = Buffer.from(`${apiUser}:${apiPass}`, 'utf8').toString('base64')
        axios.defaults.headers.common['Authorization'] = $token;
        await axios.post(`${apiUrl}auth/login`)
            .then(function (response) {
                axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.access_token}`;
                axios.defaults.headers.common['pageId'] = pageId;
                dispatch({ type: SET_AUTH, payload: true });

            })
            .catch(function (error) {
                toastr.error('There was an error in setting up a secure connection. Please try again later!');
                dispatch({ type: SET_AUTH, payload: false });

            });
    }
    // get landing page data
    const getPageInfo = async () => {
        setLoading('lead');
        const res = await axios.get(`${apiUrl}feed/${pageId}?lead=${localStorage.getItem('lead_token')}`);
        if (res.data.code === 200) {
            dispatch({ type: SET_PAGE_INFO, payload: res.data });

        } else {
            alert(res.data.message);
            dispatch({ type: RESET_FLOW, payload: 3 });
        }

    }
    // get lead
    const getLead = async (token) => {
        setLoading('lead');
        const res = await axios.get(`${apiUrl}lead/continue/${token}`);
        // console.log(res);
        // return;
        if (res.data.code === 200) {
            dispatch({ type: SET_LEAD, payload: res.data.message });

        } else {
            // toastr.error(res.data.message);
            dispatch({ type: RESET_FLOW, payload: 1 });
        }
    }
    // Set loading
    const setLoading = ($method) => {
        switch ($method) {
            case 'lead':
                dispatch({ type: SET_LEAD_LOADING });
                break;
            case 'step':
                dispatch({ type: SET_STEP_LOADING });
                break;
        }
    }
    const hideLoading = ($method) => {
        switch ($method) {
            case 'lead':
                dispatch({ type: HIDE_LEAD_LOADING });
                break;
            case 'step':
                dispatch({ type: HIDE_STEP_LOADING });
                break;
        }
    }
    // go to next step
    const gotoNextStep = async (data) => {
        setLoading('step');
        let postUrl = null;
        if (!lead) {
            postUrl = `${apiUrl}newlead`;
        } else {
            postUrl = `${apiUrl}lead/next-step/${state.lead.id}`
        }
        if (utm_source) {
            data['utm_source'] = utm_source;
        }
        if (utm_campaign) {
            data['utm_campaign'] = utm_campaign;
        }
        let PostData = data;
        // console.log(PostData);

        if (PostData['kyc_voided'] || PostData['kyc_license'] || PostData['kyc_businessLicense']) {
            // $.each(PostData['files'], (i, val) => {
            // let formData = new FormData();
            //     formData.append('files[]', val, val.name);
            // });
            let formData = new FormData();
            if (PostData['kyc_voided']) {
                formData.append('kyc_voided', PostData['kyc_voided'], PostData['kyc_voided'].name);
            }
            if (PostData['kyc_license']) {
                formData.append('kyc_license', PostData['kyc_license'], PostData['kyc_license'].name);
            }
            if (PostData['kyc_businessLicense']) {
                formData.append('kyc_businessLicense', PostData['kyc_businessLicense'], PostData['kyc_businessLicense'].name);
            }

            PostData = formData;
        }
        // return;
        await axios.post(postUrl, PostData)
            .then(function (response) {
                if (response.data.message) {
                    dispatch({ type: SET_LEAD, payload: response.data.message });
                    localStorage.setItem('lead_token', response.data.message.token);
                    document.cookie = `lead_token=${response.data.message.token}`
                    let $timeout;
                    getPageInfo();
                    $timeout = setTimeout(() => {
                        clearTimeout($timeout);
                        $('html, body').animate({
                            scrollTop: $("body").offset().top
                        }, 500);

                    }, 150);
                } else {
                    toastr.error(response.message);
                    hideLoading('step');
                }
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status == 422) {
                        let $title = error.response.statusText;
                        let $errString = '';
                        $.each(error.response.data.errors, (i, val) => {
                            $errString += `${val}<br />`;
                            if (i == 'ownership_percentage') {
                                $('#perc_col').addClass('is-invalid');
                                $('*[name="ownership_percentage"]').addClass('is-invalid');

                            }
                        });
                        toastr.error($errString, $title);
                    }
                    if (error.response.status == 404) {
                        toastr.error('The resource you requested was not found');
                    }
                    if (error.response.status == 500) {
                        console.log(error.response)
                        toastr.error(error.response.data.message, 500);
                    }
                } else {
                    console.log(error);
                }
                hideLoading('step');
            })
    }

    // go back 1 step
    const goBack = async () => {
        setLoading('step');
        if (lead) {
            const postUrl = apiUrl + "lead/prev-step/" + state.lead.id;
            await axios.post(postUrl)
                .then(function (response) {
                    if (response.data.message) {
                        dispatch({ type: SET_LEAD, payload: response.data.message });
                    } else {
                        alert('An error occured');
                        console.log(response);
                    }
                })
                .catch(function (error) {
                    alert('An error occured');
                    console.log(error);
                });
        } else {
            dispatch({ type: GO_BACK, payload: step - 1 });
        }
    }
    const deleteKyc = async ($id) => {
        setLoading('step');

        if (lead) {
            const postUrl = apiUrl + "lead/delete-kyc/" + $id;
            await axios.get(postUrl)
                .then(function (response) {
                    if (response.data.message) {
                        dispatch({ type: SET_LEAD, payload: response.data.message });
                    } else {
                        alert('An error occured');
                        console.log(response);
                    }
                })
                .catch(function (error) {
                    // alert('An error occured');
                    toastr.error(error.message);
                    hideLoading('step');
                    // console.log(error);
                });
        } else {
            dispatch({ type: GO_BACK, payload: step - 1 });
        }
    }

    // generate contract
    const getContract = async (event) => {
        event.preventDefault();
        if (docusignJWT) {

        } else {

            const postUrl = apiUrl + "lead/docusign/jwt";
            setLoading('step');
            await axios.get(postUrl)
                .then(function (reply) {
                    var response = reply.data;
                    // console.log(response);
                    if (response.errorCode || response.code === 500 || response.code === 401) {
                        toastr.error(response.message);
                        hideLoading('step');
                    }
                    if (response.error) {
                        toastr.error(response.error);
                        hideLoading('step');
                    }
                    if (response.access_token) {
                        const postUrl = `${apiUrl}lead/contract/${state.lead.id}/${response.access_token}`;
                        setLoading('step');
                        axios.get(postUrl)
                            .then(function (reply) {
                                var response = reply.data;
                                console.log(response);
                                if (response.errorCode || response.code === 500) {
                                    toastr.error(response.message, 'Error');
                                    hideLoading('step');
                                }
                                if (response.code === 200) {
                                    window.location.href = response.message;
                                }
                            })
                            .catch(function (error) {
                                toastr.error(error.message, 'Error');
                                hideLoading('step');
                            });
                    }
                })
                .catch(function (error) {
                    toastr.error(error.message, 'Error');
                    hideLoading('step');
                });
        }
    }
    // set signed status on contract
    const setDocusignEvent = async ($event, $token) => {
        const postUrl = `${apiUrl}lead/sign/${$event}/${$token}`;
        setLoading('step');
        await axios.get(postUrl);
        getLead($token);
        switch ($event) {
            case 'cancel':
                toastr.error('Signing Cancelled');
                break;
            case 'decline':
                toastr.error('Signing Declined');
                break;
            case 'signing_complete':
                toastr.success('Signing Complete');
                break;
            default:

        }
    }
    const toggleModal = (name) => {
        dispatch({ type: TOGGLE_MODAL, payload: name })
    }
    const { lp, lead, leadLoading, stepLoading, step, modal } = state;
    return <AuthContext.Provider value={{ lp, lead, leadLoading, stepLoading, step, getToken, getLead, getPageInfo, gotoNextStep, goBack, toggleModal, modal, getContract, setDocusignEvent, deleteKyc }}>
        {props.children}
    </AuthContext.Provider>
}

export default AuthState
